/**
 * Stripe Connect Service
 * Handles all Stripe Connect related API calls
 *
 * @module services/StripeConnectService
 */

import BaseService from "core/api/BaseService";

class StripeConnectService extends BaseService {
  constructor() {
    super("/stripe-connect");
  }

  async createAccount(country = "RO") {
    return this.post("create-account", { country });
  }

  async getAccountStatus() {
    return this.get("account-status");
  }

  async getAccountLink() {
    return this.post("account-link");
  }

  async getDashboardLink() {
    return this.get("dashboard-link");
  }

  async getEarnings() {
    return this.get("earnings");
  }
}

export default new StripeConnectService();
